
export type LabelType = Record<string, Record<string, string>>


export enum LanguageEnum {
    en = 'en',
    ne = 'ne',
  }
  